import { useState, useEffect } from 'react';

/**
 * Estima os segundos decorridos dentro do minuto atual do jogo.
 *
 * A API só fornece minutos inteiros (`tempo_jogo`), sem segundos reais — este
 * hook conta localmente a partir de 0 a cada minuto novo, só como indicador
 * visual de que o relógio está "vivo" entre um poll e outro. Congela em 59
 * quando passa muito tempo sem atualização (ex: poll atrasado) em vez de
 * inferir um novo minuto — só o servidor pode avançar o minuto de verdade.
 */
export function useSegundosEstimados(tempoJogo: string | null | undefined): number {
  const [segundos, setSegundos] = useState(0);

  useEffect(() => {
    setSegundos(0);
    if (!tempoJogo || !/^\d+$/.test(tempoJogo)) return;

    const t = setInterval(() => {
      setSegundos((s) => Math.min(59, s + 1));
    }, 1000);
    return () => clearInterval(t);
  }, [tempoJogo]);

  return segundos;
}
